import React, { useState, useEffect } from "react";

const UnsubscribeModal = ({ email, onClose }) => {
  const [isProcessing, setIsProcessing] = useState(true);
  const [message, setMessage] = useState("Processing your request...");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const handleUnsubscribe = async () => {
      if (!email) {
        setStatus("error");
        setMessage("Invalid unsubscribe link");
        setIsProcessing(false);
        return;
      }

      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_API_URL}/unsubscribe`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ email }),
          }
        );

        const data = await response.json();

        if (data.ok) {
          if (data.alreadyUnsubscribed) {
            setStatus("already");
            setMessage("You were already unsubscribed from our newsletter.");
          } else {
            setStatus("success");
            setMessage("You have been successfully unsubscribed. We're sorry to see you go! 😢");
          }
        } else {
          setStatus("error");
          setMessage(data.message || "Something went wrong. Please try again.");
        }
      } catch (error) {
        console.error("Unsubscribe error:", error);
        setStatus("error");
        setMessage("An error occurred. Please try again later.");
      } finally {
        setIsProcessing(false);
      }
    };

    handleUnsubscribe();
  }, [email]);

  const getIcon = () => {
    switch (status) {
      case "loading":
        return "⏳";
      case "success":
        return "✓";
      case "already":
        return "ℹ️";
      case "error":
        return "⚠️";
      default:
        return "⏳";
    }
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
        onClick={onClose}
      >
        <div
          style={{
            backgroundColor: "white",
            borderRadius: "12px",
            padding: "40px",
            maxWidth: "500px",
            width: "90%",
            textAlign: "center",
            boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
            position: "relative",
            animation: "fadeIn 0.3s ease-in-out",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {!isProcessing && (
            <button
              onClick={onClose}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                background: "transparent",
                border: "none",
                fontSize: "28px",
                cursor: "pointer",
                color: "#999",
                lineHeight: 1,
                padding: "0",
                width: "30px",
                height: "30px",
              }}
            >
              ×
            </button>
          )}

          <div style={{ fontSize: "60px", marginBottom: "20px" }}>
            {getIcon()}
          </div>

          <h2 style={{ marginBottom: "15px", color: "#333" }}>
            {isProcessing ? "Processing..." : "Newsletter Unsubscribe"}
          </h2>

          <p
            style={{
              color: "#666",
              marginBottom: isProcessing ? "20px" : "30px",
              fontSize: "16px",
              lineHeight: "1.6",
            }}
          >
            {message}
          </p>

          {!isProcessing && (
            <button
              onClick={onClose}
              style={{
                padding: "12px 30px",
                fontSize: "16px",
                fontWeight: "600",
                backgroundColor: "#007bff",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
            >
              Close
            </button>
          )}

          {isProcessing && (
            <div
              style={{
                display: "inline-block",
                width: "40px",
                height: "40px",
                border: "4px solid #f3f3f3",
                borderTop: "4px solid #007bff",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
              }}
            />
          )}
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default UnsubscribeModal;